export const PAY_LOAN_CONFIRMATION_START =
  'PAY_LOAN_CONFIRMATION_START';
export const PAY_LOAN_CONFIRMATION_SUCCESS =
  'PAY_LOAN_CONFIRMATION_SUCCESS';
export const PAY_LOAN_CONFIRMATION_ERROR =
  'PAY_LOAN_CONFIRMATION_ERROR';
export const PAY_LOAN_CONFIRMATION_END = 'PAY_LOAN_END';
export const CLEAR_PAY_LOAN_CONFIRMATION =
  'CLEAR_PAY_LOAN_CONFIRMATION';
